module.exports = __webpack_public_path__ + "img/BABO-04.2c55ffc1.png";